import { useI18n, SUPPORTED_LANGS } from "@/lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "@phosphor-icons/react";

export default function LanguageSwitcher({ compact = false, testid = "lang-switcher" }) {
  const { lang, setLang } = useI18n();

  return (
    <div className="inline-flex items-center gap-1">
      {!compact && <Globe size={14} className="text-zinc-400" />}
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger
          data-testid={testid}
          className="w-[92px] sm:w-[108px] h-9 bg-[#1A1A1A] border-zinc-700 text-white text-xs"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#1A1A1A] border-zinc-700">
          {SUPPORTED_LANGS.map((l) => (
            <SelectItem
              key={l.code}
              value={l.code}
              data-testid={`${testid}-${l.code}`}
              className="text-white hover:bg-zinc-800 focus:bg-zinc-800"
            >
              {l.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
